import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import TertiaryButton from '../Button/TertiaryButton';
import SecondaryButton from '../Button/SecondaryButton';

interface Prop {
  Heading?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  title: any;
  onLeftHandler?: any;
  onRightHandler?: any;
  titleLeft?: string;
  titleRight?: string;
  btnSizeLeft?: 'sm' | 'lg';
  btnSizeRight?: 'sm' | 'lg';
  iconRight?: amy;
  isBig?: boolean;
}

export default function TitleComponent({
  Heading = 'h1',
  title,
  onLeftHandler = null,
  onRightHandler = null,
  titleLeft = 'Back',
  titleRight = 'Next',
  btnSizeLeft = undefined,
  btnSizeRight = undefined,
  iconRight,
  isBig = false,
}: Prop): JSX.Element {
  return (
    <Heading>
      {onLeftHandler && (
        <StyledButtonLeft>
          <TertiaryButton size={btnSizeLeft} onClick={onLeftHandler} title={titleLeft} />
        </StyledButtonLeft>
      )}
      {onRightHandler && (
        <StyledButtonRight>
          <SecondaryButton
            isBig={isBig}
            size={btnSizeRight}
            onClick={onRightHandler}
            title={titleRight}
            icon={iconRight}
          />
        </StyledButtonRight>
      )}
      <StyledSpan>{title}</StyledSpan>
    </Heading>
  );
}

const StyledSpan = styled.span`
  white-space: pre-line;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #642b26;
  font-size: 40px;
  font-weight: 700;
`;

const StyledButtonLeft = styled.div`
  & button {
    float: left;
  }
`;

const StyledButtonRight = styled.div`
  & button {
    float: right;
  }
`;
